import {
  Toaster as ChakraToaster,
  ToastCloseTrigger,
  ToastDescription,
  ToastIndicator,
  ToastRoot,
  ToastTitle,
  createToaster,
  chakra,
  Stack,
} from '@chakra-ui/react'

export const toaster = createToaster({
  placement: 'top',
  pauseOnPageIdle: true,
})

// ToastIndicator は info 用のアイコンを持たず null を返すため自前で描画する。
// パスは @chakra-ui/react 内部の InfoIcon と同一（公開exportされていないため直接importはしない）
const ToastInfoIcon = () => (
  <chakra.svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="0" flexShrink="0" boxSize="5" aria-hidden="true" focusable="false">
    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z" />
  </chakra.svg>
)

export const Toaster = () => (
  <ChakraToaster toaster={toaster}>
    {(toast) => (
      <ToastRoot maxW="sm">
        {toast.type === 'info' ? <ToastInfoIcon /> : <ToastIndicator />}
        <Stack gap="1" flex="1" maxWidth="100%">
          {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
          {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
        </Stack>
        <ToastCloseTrigger />
      </ToastRoot>
    )}
  </ChakraToaster>
)
